import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(
      // Orden de la cadena (auth innermost): en la RESPUESTA, auth ve el 401
      // primero para refrescar y reintentar antes de que error muestre un toast.
      withInterceptors([loadingInterceptor, errorInterceptor, authInterceptor]),
    ),
  ],
};
